var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRilinkedinfill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.63339 4.65089C5.63318 5.05622 5.47197 5.44487 5.18522 5.73134C4.89846 6.01781 4.50965 6.17863 4.10432 6.17843C3.69899 6.17823 3.31034 6.01702 3.02387 5.73026C2.7374 5.44351 2.57658 5.0547 2.57678 4.64936C2.57699 4.24403 2.7382 3.85538 3.02495 3.56892C3.31171 3.28245 3.70052 3.12162 4.10585 3.12183C4.51118 3.12203 4.89983 3.28324 5.1863 3.57C5.47277 3.85675 5.63359 4.24556 5.63339 4.65089ZM5.67924 7.31014L2.62263 7.31014L2.62263 16.8773H5.67924L5.67924 7.31014ZM10.5087 7.31014H7.46735L7.46735 16.8773H10.4781V11.8568C10.4781 9.06005 14.1231 8.80023 14.1231 11.8568V16.8773H17.1415V10.8176C17.1415 6.10278 11.7466 6.27854 10.4781 8.59391L10.5087 7.31014Z",
    fill: "#2F2D26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRilinkedinfill);
export default __webpack_public_path__ + "static/media/rilinkedinfill.0924a2d3a6fc6a0ff1af108ee3a49044.svg";
export { ForwardRef as ReactComponent };